(function () {
  'use strict';

  var STYLE_ID = 'impulse-footer-final-desktop-style';
  var BLOCK_CLASS = 'impulse-newsletter-hardfix';

  function footerRoot() {
    return document.querySelector('footer');
  }

  function ensureStyle() {
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = '' +
      '@media (min-width:901px){' +
        'html body footer .' + BLOCK_CLASS + '{' +
          'display:flex!important;' +
          'flex-direction:column!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'width:min(calc(100vw - 96px),840px)!important;' +
          'max-width:840px!important;' +
          'margin:48px auto 44px!important;' +
          'padding:42px 20px 38px!important;' +
          'text-align:center!important;' +
          'box-sizing:border-box!important;' +
          'background:transparent!important;' +
          'border-top:1px solid rgba(0,0,0,.10)!important;' +
          'border-bottom:1px solid rgba(0,0,0,.10)!important;' +
          'border-left:0!important;' +
          'border-right:0!important;' +
          'box-shadow:none!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + ' *{box-sizing:border-box!important;}' +
        'html body footer .' + BLOCK_CLASS + '__title{' +
          'display:block!important;' +
          'width:100%!important;' +
          'max-width:760px!important;' +
          'margin:0 auto 16px!important;' +
          'padding:0!important;' +
          'text-align:center!important;' +
          'font-size:clamp(32px,2.75vw,48px)!important;' +
          'line-height:1.05!important;' +
          'letter-spacing:-.05em!important;' +
          'font-weight:500!important;' +
          'color:#111!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__strong{' +
          'display:block!important;' +
          'width:100%!important;' +
          'max-width:690px!important;' +
          'margin:0 auto 18px!important;' +
          'padding:0!important;' +
          'text-align:center!important;' +
          'font-size:clamp(20px,1.55vw,27px)!important;' +
          'line-height:1.22!important;' +
          'letter-spacing:-.02em!important;' +
          'font-weight:850!important;' +
          'color:#111!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__text{' +
          'display:block!important;' +
          'width:100%!important;' +
          'max-width:760px!important;' +
          'margin:0 auto!important;' +
          'padding:0!important;' +
          'text-align:center!important;' +
          'color:#555!important;' +
          'font-size:clamp(18px,1.38vw,23px)!important;' +
          'line-height:1.42!important;' +
          'font-weight:400!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__benefits{' +
          'display:flex!important;' +
          'justify-content:center!important;' +
          'align-items:center!important;' +
          'flex-wrap:wrap!important;' +
          'gap:10px!important;' +
          'width:100%!important;' +
          'max-width:760px!important;' +
          'margin:24px auto 30px!important;' +
          'padding:0!important;' +
          'list-style:none!important;' +
          'text-align:center!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__benefits li{' +
          'display:inline-flex!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'min-height:32px!important;' +
          'margin:0!important;' +
          'padding:0 14px!important;' +
          'border:1px solid rgba(30,144,255,.28)!important;' +
          'border-radius:999px!important;' +
          'background:rgba(30,144,255,.07)!important;' +
          'color:#1848a0!important;' +
          'font-size:14px!important;' +
          'font-weight:850!important;' +
          'line-height:1!important;' +
          'white-space:nowrap!important;' +
          'list-style:none!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__benefits li::marker{content:""!important;font-size:0!important;}' +
        'html body footer .' + BLOCK_CLASS + '__form{' +
          'display:grid!important;' +
          'grid-template-columns:minmax(0,1fr) 164px!important;' +
          'gap:10px!important;' +
          'align-items:stretch!important;' +
          'width:min(100%,740px)!important;' +
          'max-width:740px!important;' +
          'margin:0 auto!important;' +
          'padding:0!important;' +
          'background:transparent!important;' +
          'border:0!important;' +
          'box-shadow:none!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__form input[type=email]{' +
          'display:block!important;' +
          'width:100%!important;' +
          'min-width:0!important;' +
          'max-width:none!important;' +
          'height:52px!important;' +
          'min-height:52px!important;' +
          'margin:0!important;' +
          'padding:0 18px!important;' +
          'border:1px solid rgba(0,0,0,.48)!important;' +
          'border-radius:0!important;' +
          'background:#fff!important;' +
          'color:#111!important;' +
          'opacity:1!important;' +
          'visibility:visible!important;' +
          'font-size:15px!important;' +
          'line-height:52px!important;' +
          'text-align:left!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + '__form button{' +
          'display:flex!important;' +
          'align-items:center!important;' +
          'justify-content:center!important;' +
          'width:164px!important;' +
          'min-width:164px!important;' +
          'max-width:164px!important;' +
          'height:52px!important;' +
          'min-height:52px!important;' +
          'margin:0!important;' +
          'padding:0 14px!important;' +
          'border-radius:0!important;' +
          'white-space:nowrap!important;' +
          'font-size:13px!important;' +
          'font-weight:500!important;' +
          'line-height:1!important;' +
          'text-align:center!important;' +
        '}' +
        'html body footer .impulse-newsletter-clean,' +
        'html body footer .impulse-club-form-custom,' +
        'html body footer .impulse-newsletter-zone:not(.' + BLOCK_CLASS + '),' +
        'html body footer .impulse-club-copy,' +
        'html body footer .impulse-club-benefits{' +
          'display:none!important;' +
          'visibility:hidden!important;' +
          'height:0!important;' +
          'max-height:0!important;' +
          'overflow:hidden!important;' +
          'margin:0!important;' +
          'padding:0!important;' +
          'border:0!important;' +
        '}' +
        'html body footer h1:not(.' + BLOCK_CLASS + '__title),' +
        'html body footer h2:not(.' + BLOCK_CLASS + '__title),' +
        'html body footer h3:not(.' + BLOCK_CLASS + '__title){' +
          'display:none!important;' +
          'visibility:hidden!important;' +
          'height:0!important;' +
          'max-height:0!important;' +
          'overflow:hidden!important;' +
          'margin:0!important;' +
          'padding:0!important;' +
        '}' +
        'html body footer form:not(.' + BLOCK_CLASS + '__form):has(input[type=email]),' +
        'html body footer [class*=email-signup]:has(input[type=email]){' +
          'display:none!important;' +
          'visibility:hidden!important;' +
          'height:0!important;' +
          'max-height:0!important;' +
          'overflow:hidden!important;' +
          'margin:0!important;' +
          'padding:0!important;' +
          'border:0!important;' +
        '}' +
        'html body footer .' + BLOCK_CLASS + ' + .shopify-section,' +
        'html body footer .' + BLOCK_CLASS + ' ~ .shopify-section{' +
          'max-width:860px!important;' +
          'margin-left:auto!important;' +
          'margin-right:auto!important;' +
        '}' +
        'html body footer a{text-decoration:none!important;}' +
      '}' +
      '@media (max-width:900px){' +
        'html body footer .' + BLOCK_CLASS + '{display:none!important;}' +
      '}';
  }

  function createBlock() {
    var section = document.createElement('section');
    section.className = BLOCK_CLASS;
    section.setAttribute('aria-label', 'Newsletter Impulse Padel');
    section.innerHTML = '' +
      '<h2 class="' + BLOCK_CLASS + '__title">Rejoignez le Club Impulse</h2>' +
      '<div class="' + BLOCK_CLASS + '__strong">Votre accès privilégié à l’univers Impulse Padel.</div>' +
      '<p class="' + BLOCK_CLASS + '__text">Recevez en avant-première nos lancements, toutes nos actualités et nos conseils terrain pour progresser et performer au padel.</p>' +
      '<ul class="' + BLOCK_CLASS + '__benefits" aria-label="Avantages du Club Impulse"><li>Avant-premières</li><li>Actualités Impulse</li><li>Conseils performance</li></ul>' +
      '<form class="' + BLOCK_CLASS + '__form" method="post" action="/contact#ContactFooter" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="newsletter">' +
        '<input type="email" name="contact[email]" placeholder="Adresse e-mail" autocomplete="email" required>' +
        '<button type="submit">Entrer dans le Club</button>' +
      '</form>';
    return section;
  }

  function keepSingleBlock(root) {
    var blocks = Array.prototype.slice.call(root.querySelectorAll('.' + BLOCK_CLASS));
    var block = blocks[0];

    blocks.slice(1).forEach(function (duplicate) {
      duplicate.remove();
    });

    if (!block) block = createBlock();

    if (block.parentNode !== root || root.firstElementChild !== block) {
      root.insertBefore(block, root.firstElementChild);
    }
  }

  var scheduled = false;
  function run() {
    ensureStyle();
    var root = footerRoot();
    if (!root) return;
    keepSingleBlock(root);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', run);
  setTimeout(run, 0);
  setTimeout(run, 150);
  setTimeout(run, 600);
  setTimeout(run, 1200);

  if (document.body) {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
})();
